module.exports = __webpack_public_path__ + "static/media/events_button.c6c6f3e9.png";